export default "__VITE_ASSET__CcsM0V30__"